import React from 'react'
import { FaGithub } from "react-icons/fa";


const DiscoverMore = () => {

    return (
        <div className='flex flex-col items-center h-full justify-evenly'>
            <h3 className='pb-2 text-lg font-semibold'>Want to See More My Creations ?</h3>
            <a href='https://github.com/mohammedshibinv' className='p-8 text-4xl border-2 rounded-full border-darkTheme-bg-tertiary'>
                <FaGithub />
            </a>
        </div>
    )
}

export default DiscoverMore